import React from 'react';

// @atlaskit
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import Tooltip from '@atlaskit/tooltip';

// @source
import { env } from '../../../utils';
import { RBSReportIcon } from '../../media';

const PrimaryIcon = (
  <Tooltip content={env('APP_NAME')} position="right">
    <RBSReportIcon width={28} fill="currentColor" />
  </Tooltip>
);

const DrawerBackButton = () => (
  <Tooltip content="Close Drawer" position="right">
    <ArrowLeftIcon label="Back icon" size="medium" />
  </Tooltip>
);

export {
  DrawerBackButton,
  PrimaryIcon,
};
